var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93333 1.04444V4.37778C9.93333 4.99444 10.4333 5.48889 11.0444 5.48889H14.3778L9.93333 1.04444ZM11.0444 7.71111C9.21111 7.71111 7.71111 6.21667 7.71111 4.37778V0H2.22222C0.994444 0 0 0.994444 0 2.22222V17.7778C0 19.0056 0.994444 20 2.22222 20H13.3333C14.5611 20 15.5556 19.0056 15.5556 17.7778V7.71111H11.0444ZM4.44444 8.33333H8.88889C9.5 8.33333 10 8.83333 10 9.44444C10 10.0556 9.5 10.5556 8.88889 10.5556H4.44444C3.83333 10.5556 3.33333 10.0556 3.33333 9.44444C3.33333 8.83333 3.83333 8.33333 4.44444 8.33333ZM11.6667 15.5556H4.44444C3.83333 15.5556 3.33333 15.0556 3.33333 14.4444C3.33333 13.8333 3.83333 13.3333 4.44444 13.3333H11.6667C12.2778 13.3333 12.7778 13.8333 12.7778 14.4444C12.7778 15.0556 12.2778 15.5556 11.6667 15.5556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio);
export default __webpack_public_path__ + "static/media/bio.a7da64b3abcc95afd0531268a4b04416.svg";
export { ForwardRef as ReactComponent };